export default __webpack_public_path__ + "static/media/3.9ba7d3d9.png";